import { Injectable, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { IInfoCardData, ISearchCriteria } from "@tylertech/tyler-api-types";
import { EditDialogComponent, EditDialogData, InfoCardSearchDialogComponent, InfoCardSearchDialogData } from "../components";
import { InfoCardCustomCardMap } from "../interfaces";

@Injectable({ providedIn: "root" })
export class InfoCardDialogService
{
    private readonly matDialog = inject(MatDialog);


    /**
     * @param customCards Optional custom header/detail cards keyed by search provider id, for
     * providers whose results need more than the default card layout.
     */
    showSearchDialog(criteria: ISearchCriteria<IInfoCardData>, customCards?: InfoCardCustomCardMap): Promise<void>
    {
        const dialogConfig: MatDialogConfig<InfoCardSearchDialogData> = {
            data: { criteria, customCards }
        };
        const dialogRef = this.matDialog.open(InfoCardSearchDialogComponent, dialogConfig);

        return dialogRef.afterClosed().toPromise();
    }

    showEditDialog(item: IInfoCardData, addMode: boolean, editComponent?: string): Promise<IInfoCardData>
    {
        const dialogConfig: MatDialogConfig<EditDialogData> = {
            data: {
                item,
                addMode,
                editComponent
            }
        };
        const dialogRef = this.matDialog.open(EditDialogComponent, dialogConfig);

        return dialogRef.afterClosed().toPromise();
    }
}
